import { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';
import AppRouter from './appRouterSimple';
import './styles/styles.css';

function App() {
  const [session, setSession] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isFromInvitation, setIsFromInvitation] = useState(false);

  useEffect(() => {
    let ignore = false;

    const getSessionAndProfile = async () => {
      const { data: { session } } = await supabase.auth.getSession();

      if (!ignore) {
        setSession(session);
        if (session) {
          // 👇 Obtenemos también el role del usuario (admin o employee)
          const { data: profile, error } = await supabase
            .from('profiles')
            .select('role')
            .eq('id', session.user.id)
            .single();

          if (error) {
            console.error('Error fetching user profile:', error);
            setUserRole(null);
          } else {
            setUserRole(profile?.role);
          }
        }
        setLoading(false);
      }
    };

    const checkInvitationParams = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const invitationToken = urlParams.get('token');
      const invitationEmail = urlParams.get('email');
      
      if (invitationToken && invitationEmail) {
        setIsFromInvitation(true);
      }
    };

    getSessionAndProfile();
    checkInvitationParams();

    const { data: listener } = supabase.auth.onAuthStateChange((_event, newSession) => {
      if (!ignore) {
        setSession(newSession);
        // 👇 Cuando cambia la sesión, refrescamos el rol
        if (newSession) {
          const fetchRole = async () => {
            const { data: profile, error } = await supabase
              .from('profiles')
              .select('role')
              .eq('id', newSession.user.id)
              .single();
            if (!error) {
              setUserRole(profile?.role);
            }
          };
          fetchRole();
        } else {
          setUserRole(null);
        }
      }
    });

    return () => {
      ignore = true;
      listener?.subscription.unsubscribe();
    };
  }, []);

  if (loading) {
    return <div className="loading-state">Cargando...</div>;
  }

  return (
    <AppRouter 
      session={session} 
      userRole={userRole} 
      isFromInvitation={isFromInvitation} 
    />
  );
}

export default App;
